<div class="contentContainer">
	<main class="contentContainer-main">
		<ng-container *ngIf="!failedProductFetch">
			<div #headerBanner id="header-banner" class="dynamic-content-canvas"></div>
			<div #shelfBanner id="shelf-banner" class="dynamic-content-canvas"></div>
			<div #dynamicContentGlobal id="dynamic-content-global-panel" class="dynamic-content-canvas"></div>
		</ng-container>

		<div id="product-details" class="row-fluid mrow-fluid product" *ngIf="product && !failedProductFetch">
			<product-seo [product]="product"></product-seo>
			<div class="span6">
				<div class="product-detail-tablet" *ngIf="isNewPDPEnabled$ | async">
					<h1 class="product-title">{{ productTitle | titlecase | capitalizeSpecificWords }}</h1>
					<product-price-meta
						[size]="product.size"
						[cupPrice]="cupPrice"
						[uniqueId]="topUniqueId"
						[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
					>
					</product-price-meta>
					<div
						class="product-averagePrice"
						*ngIf="!isItemAlreadyAddedByKg && product?.supportsBothEachAndKgPricing"
					>
						<product-price-single-unit-average
							[singleUnitPrice]="product?.price?.averagePricePerSingleUnit"
							[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
							[departmentName]="productDepartmentName"
							[packageType]="product?.size?.packageType"
						>
						</product-price-single-unit-average>
					</div>
					<div class="product-meta-with-stock-level">
						<div *ngIf="productIsAvailable" class="product-meta">
							<product-price
								[uniqueId]="topUniqueId"
								[price]="product.price"
								[unit]="product.unit"
								[isProductTagClubPrice]="isProductTagClubPrice"
							></product-price>
							<div
								class="product-eachKgSelector"
								*ngIf="product.supportsBothEachAndKgPricing && !isEachKgItemAdded"
							>
								<product-each-kg-selector
									[uniqueId]="topUniqueId"
									[purchasingUnit]="product?.selectedPurchasingUnit"
									(unitChangeEmitter)="handlePurchasingUnitChange($event)"
								></product-each-kg-selector>
							</div>
						</div>
						<wnz-product-stock-level-indicator
							*ngIf="isMerchantStorefrontEnabled"
							class="product-stock-level"
							[stockLevel]="stockLevel"
							[storeName]="mhlsStoreName"
							[storeAddress]="mhlsPickupAddressDetails"
						>
						</wnz-product-stock-level-indicator>
					</div>
					<div class="product-controls">
						<cdx-notification
							#notification
							*ngIf="productIsAvailable"
							iconName="tick-sign"
							colour="green"
							[content]="inTrolleyText"
							[canShow]="showNotification"
							[floating]="true"
						>
						</cdx-notification>

						<product-add-to-trolley
							[id]="product.sku"
							[title]="product.name"
							[unit]="unit"
							[productIsInStock]="productIsInStock"
							[productIsAvailable]="productIsAvailable"
							[shopper]="productService?.shopper?.isShopper"
							(addToTrolleyEmitter)="addToTrolleyClick()"
							(updateQuantityEmitter)="updateQuantity($event)"
							(changeEmitter)="addToTrolleyClick()"
						>
						</product-add-to-trolley>

						<button
							*ngIf="isMerchantStorefrontEnabled"
							cdxButton
							(click)="checkStockInOtherStores()"
							fillStyle="link"
							class="check-stock-availability"
							i18n="@@storeSummary-stockavailability"
							[cdxTrackEvent]="{
											event: trackingEvent.NotificationEvent,
											type: notificationType.Modal,
											name: 'stock availability check',
											value: ''
										}"
						>
							<cdx-svg-icon
								class="location-icon"
								name="location-pin-filled"
								fill="green"
								[size]="'small'"
							></cdx-svg-icon>
							Check stock in other stores
						</button>
					</div>
					<edr-app-boost-details-card
						*ngIf="boostOfferTag?.boostOffer as boostOffer"
						[offerId]="boostOffer.offerId"
					/>

					<div id="dynamic-content-title" class="dynamic-content-canvas" *ngIf="productIsAvailable"></div>
				</div>
				<div class="product-mainImage" aria-hidden="true">
					<div class="product-tags" *ngIf="productTags">
						<ul>
							<li *ngIf="boostOfferTag?.boostOffer?.rewardValue?.points as boostOfferPoints">
								<edr-roundel
									[roundelText]="roundelText({ points: boostOfferTag?.boostOffer.rewardValue.points, value: boostOfferTag?.boostOffer.rewardValue.value, type: boostOfferTag?.boostOffer.rewardValue.type })"
									[attr.tabindex]="(tabindex$ | async)"
								/>
							</li>
							<li *ngFor="let tag of productTags" [tag]="tag" productTag [price]="product?.price"></li>
							<li *ngIf="product.healthStarRating">
								<img
									class="product-healthStar"
									alt="{{product.name}}"
									src="/assets/images/product-details/health-star-rating/{{ product.healthStarRating }}.png"
								/>
							</li>
						</ul>
					</div>

					<figure
						cdxProductImage
						[images]="mainImage"
						[name]="product.name + ' image ' + (currentMainImageIndex + 1)"
						size="zoom"
						ImageZoom
						labelledBy="product-title"
					></figure>
				</div>

				<div
					class="product-thumbs"
					aria-hidden="true"
					[ngClass]="{ 'product-thumbs--hidden': shouldShowDetailTop }"
					*ngIf="product.images?.length"
				>
					<figure
						cdxProductImage
						*ngFor="let image of product.images; let i = index"
						[name]="product.name + ' image ' + (i + 1)"
						[images]="image"
						size="thumb"
						[attr.tabindex]="tabindex$ | async"
						(click)="setAsMainImage(i)"
						(keydown)="handleKeydown($event)"
						[attr.data-index]="i"
						[class.selected]="i === currentMainImageIndex"
					></figure>
				</div>
			</div>
			<div class="span6">
				<div class="product-detail-top" [ngClass]="{ 'product-detail-top--hidden': shouldShowDetailTop}">
					<h1 class="product-title">{{ productTitle | titlecase | capitalizeSpecificWords }}</h1>
					<product-price-meta
						[size]="product.size"
						[cupPrice]="cupPrice"
						[uniqueId]="bottomUniqueId"
						[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
					>
					</product-price-meta>
					<div
						class="product-averagePrice"
						*ngIf="!isItemAlreadyAddedByKg && product?.supportsBothEachAndKgPricing"
					>
						<product-price-single-unit-average
							[singleUnitPrice]="product?.price?.averagePricePerSingleUnit"
							[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
							[departmentName]="productDepartmentName"
							[packageType]="product?.size?.packageType"
						>
						</product-price-single-unit-average>
					</div>
					<div class="product-meta-with-stock-level">
						<div *ngIf="productIsAvailable" class="product-meta">
							<product-price
								[uniqueId]="bottomUniqueId"
								[price]="product.price"
								[unit]="product.unit"
								[isProductTagClubPrice]="isProductTagClubPrice"
							></product-price>
							<div
								class="product-eachKgSelector"
								*ngIf="product.supportsBothEachAndKgPricing && !isEachKgItemAdded"
							>
								<product-each-kg-selector
									[uniqueId]="bottomUniqueId"
									[purchasingUnit]="product?.selectedPurchasingUnit"
									(unitChangeEmitter)="handlePurchasingUnitChange($event)"
								></product-each-kg-selector>
							</div>
						</div>
						<wnz-product-stock-level-indicator
							*ngIf="isMerchantStorefrontEnabled"
							class="product-stock-level"
							[stockLevel]="stockLevel"
							[storeName]="mhlsStoreName"
							[storeAddress]="mhlsPickupAddressDetails"
						>
						</wnz-product-stock-level-indicator>
					</div>
					<div class="product-controls">
						<cdx-notification
							#notification
							*ngIf="productIsAvailable"
							iconName="tick-sign"
							colour="green"
							[content]="inTrolleyText"
							[canShow]="showNotification"
							[floating]="true"
						>
						</cdx-notification>

						<product-add-to-trolley
							[id]="product.sku"
							[title]="product.name"
							[unit]="unit"
							[productIsInStock]="productIsInStock"
							[productIsAvailable]="productIsAvailable"
							[shopper]="productService?.shopper?.isShopper"
							(addToTrolleyEmitter)="addToTrolleyClick()"
							(updateQuantityEmitter)="updateQuantity($event)"
							(changeEmitter)="addToTrolleyClick()"
						>
						</product-add-to-trolley>

						<button
							*ngIf="isMerchantStorefrontEnabled"
							cdxButton
							(click)="checkStockInOtherStores()"
							fillStyle="link"
							class="check-stock-availability"
							i18n="@@storeSummary-stockavailability"
							[cdxTrackEvent]="{
											event: trackingEvent.NotificationEvent,
											type: notificationType.Modal,
											name: 'stock availability check',
											value: ''
										}"
						>
							<cdx-svg-icon
								class="location-icon"
								name="location-pin-filled"
								fill="green"
								[size]="'small'"
							></cdx-svg-icon>
							Check stock in other stores
						</button>
					</div>

					<edr-app-boost-details-card
						*ngIf="boostOfferTag?.boostOffer as boostOffer"
						[offerId]="boostOffer.offerId"
					/>

					<div id="dynamic-content-title" class="dynamic-content-canvas" *ngIf="productIsAvailable"></div>
				</div>

				<p class="product-description" [innerHTML]="product.description"></p>

				<p *ngIf="product.alcohol"><strong>Alcohol content:</strong> {{ product.alcohol }}%</p>

				<div id="dynamic-content-details" class="dynamic-content-canvas"></div>

				<cdx-accordion>
					<cdx-accordion-item
						*ngIf="countryOfOrigin$ | async as countryOfOrigin"
						heading="Country of origin"
						isOpened="true"
					>
						{{ countryOfOrigin }}
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="ingredients" heading="Ingredients">
						<div [innerHTML]="ingredients"></div>

						<ul *ngIf="ingredientFootnotes?.length" class="footnotes">
							<li *ngFor="let footnote of ingredientFootnotes">{{ footnote }}</li>
						</ul>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="nutrition" heading="Nutritional information">
						<p *ngIf="nutrition.servings" class="nutrition-servings">{{ nutrition.servings }}</p>

						<div class="nutrition-table">
							<table *ngIf="nutrition.columnHeaders && nutrition.rows">
								<caption class="sr-only">
									Nutritional Information Table
								</caption>
								<thead>
									<th *ngFor="let h of nutrition.columnHeaders">
										{{ h.name }}<sup>{{ h.suffix }}</sup>
									</th>
								</thead>
								<tbody>
									<ng-container *ngFor="let row of nutrition.rows">
										<tr>
											<td *ngFor="let col of row.columns">{{ col }}</td>
										</tr>
										<tr *ngFor="let subRow of row.rows" class="nutrition-tableRow--sub">
											<td *ngFor="let col of subRow.columns">{{ col }}</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>

						<ul *ngIf="nutrition.footnotes" class="footnotes">
							<li *ngFor="let f of nutrition.footnotes">
								<sup *ngIf="f.prefix">{{f.prefix}}</sup> <span [innerHTML]="f.displayText"></span>
							</li>
						</ul>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="contents" heading="Contents">
						<p>{{ contents }}</p>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="allergens" heading="Allergen warnings">
						<p>{{ allergens }}</p>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="claims" heading="Claims">
						<p>{{ claims }}</p>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="warnings" heading="Warnings">
						<p>{{ warnings }}</p>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="endorsements" heading="Endorsements">
						<p>{{ endorsements }}</p>
					</cdx-accordion-item>

					<cdx-accordion-item *ngIf="category" heading="Category">
						<p>{{ category }}</p>
					</cdx-accordion-item>

					<ng-container *ngIf="productService?.shopper?.isShopper">
						<cdx-accordion-item
							*cdxEmbedded="'hide'"
							heading="Add to saved list"
							(headingButtonToggle)="handleListAccordionHeadingClick($event)"
						>
							<cdx-alert
								[withMargin]="false"
								*ngIf="listErrored"
								type="error"
								[title]="listErrorMessage"
							></cdx-alert>

							<button
								class="product-savedList"
								cdxButton
								fillStyle="tertiaryFlat"
								align="left"
								[fullWidth]="true"
								[endSlotActive]="list.containsCurrentProduct"
								(click)="toggleProductInList(list.id, list.containsCurrentProduct)"
								*ngFor="let list of (savedLists$ | async)?.savedLists"
							>
								{{ list.name }}
								<ng-container end *ngIf="list.containsCurrentProduct">
									<cdx-svg-icon size="small" name="tick-sign" fill="dark"></cdx-svg-icon>
								</ng-container>
							</button>
						</cdx-accordion-item>
						<cdx-accordion-item heading="Personal shopper notes">
							<product-shopper-notes [sku]="product?.sku"></product-shopper-notes>
						</cdx-accordion-item>
					</ng-container>
				</cdx-accordion>

				<p class="product-footerMessage">{{ product?.productDisclaimerMessage }}</p>
			</div>
		</div>

		<div class="productDetailsError" *ngIf="failedProductFetch">
			<cdx-svg-icon size="large" name="alert" fill="currentColor"></cdx-svg-icon>
			<span class="productDetailsError-message">
				We’re sorry, it looks like something went wrong. Please try again later or contact us.</span
			>
		</div>
	</main>
</div>

<router-outlet name="pd-modal"></router-outlet>
